import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { PMSService } from '../../Services/PMSService';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { GlitchService } from '../../Services/GlitchService';
import { Glitch_UpdateRequest, Glitch_SearchRequest, ComplainAttachment, GlitchAttachment, Glitch_ActionRequest } from '../../Models/RequestModels';
import { Glitch_RegistrationTypes, AuthActionCodes, GlitchOperationActions, EntityCodes } from '../../Models/EnumModels';
import { PropertyBasicInfo, LocationLookup, GenericMaster, GlitchDescription, GlitchCategory, ReasonLookup, GlitchRecoveryOptionMaster, GlitchActionReason } from '../../Models/GlobalEntities';
import * as alasql from 'alasql';
import * as _ from "lodash";
import * as moment from 'moment';
import * as Collections from 'typescript-collections';
import { GuestLookup } from '../../Models/ResponseModels';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { GuestDetail } from '../GuestDetail/GuestDetail';
import { AppSettings } from '../../Library/AppSettings';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgbModalRef, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'GlitchAction',
    templateUrl: './GlitchAction.html'
})

export class GlitchAction extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    @ViewChild('confirm') confirm;
    Model: Glitch_ActionRequest;
    _GlitchOperationActions = GlitchOperationActions;
    Title: string;
    DataModel: any;

    ModalRef: NgbModalRef;

    ConfirmModalRef: NgbModalRef;
    ConfirmModel: any;

    lstRecoveryOptions: Array<GlitchRecoveryOptionMaster> = [];
    lstActionReasons: Array<GlitchActionReason> = [];

    PropertyId: number;
    ApprovedMaximumCost: number;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, protected glitchService: GlitchService, private modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
        this.Model = new Glitch_ActionRequest();

        this.SetModelDefaults();
    }

    SetModelDefaults(): void {
        this.Model.Operation = GlitchOperationActions.Register;
        this.Model.GlitchActionId = null;
        this.Model.GlitchId = null;
        this.Model.ReasonOrRecoveryId = 0;
        this.Model.RecoveryCost = null;
        this.Model.Remarks = null;
        this.ApprovedMaximumCost = null;
    }

    Open(PropertyId:number, GlitchId: number, GlitchActionId: number, GlitchData: any, Action: GlitchOperationActions): void {
        this.PropertyId = PropertyId;
        this.ClearErrors();        

        this.SetModelDefaults();

        this.DataModel = _.cloneDeep(GlitchData);
        this.Model.GlitchId = GlitchId;
        this.Model.Operation = Action;

        this.lstRecoveryOptions = this.masterService.GetGlitchRecoveryOptions(this.PropertyId);
        this.lstActionReasons = this.masterService.GetGlitchActionReasons(this.PropertyId);

        if (GlitchActionId != null) {
            this.Model.GlitchActionId = GlitchActionId;
            let actionData: any;
            actionData = this.DataModel.Actions.filter(a => a.GlitchActionId == this.Model.GlitchActionId);
            this.Model.ReasonOrRecoveryId = actionData[0].ReasonOrRecoveryId;
            this.Model.RecoveryCost = actionData[0].RecoveryCost;
            this.Model.Remarks = actionData[0].Remarks;

            if (this.Model.Operation == GlitchOperationActions.EditRecovery) 
                this.setMaxDiscount()
            
            this.Model.Operation = Action;
        }
        switch (this.Model.Operation) {
            case GlitchOperationActions.Close:
                this.Title = 'TITLE.TITLE_CLOSE_GLITCH';
                break;
            case GlitchOperationActions.CloseEdit:
                this.Title = 'TITLE.TITLE_CLOSE_EDIT_GLITCH';
                break;
            case GlitchOperationActions.AddRecovery:
                this.Title = 'TITLE.TITLE_ADD_RECOVERY';
                break;
            case GlitchOperationActions.EditRecovery:
                this.Title = 'TITLE.TITLE_EDIT_RECOVERY';
                break;
            case GlitchOperationActions.AddInvestigation:
                this.Title = 'TITLE.TITLE_ADD_INVESTIGATION';
                break;
            case GlitchOperationActions.EditInvestigation:
                this.Title = 'TITLE.TITLE_EDIT_INVESTIGATION';
                break;
            case GlitchOperationActions.ReOpen:
                this.Title = 'TITLE.TITLE_REOPEN_GLITCH';
                break;
            case GlitchOperationActions.ReOpenEdit:
                this.Title = 'TITLE.TITLE_REOPEN_EDIT_GLITCH';
                break; 
        }
        

        switch (this.Model.Operation) {
            case GlitchOperationActions.Close:
                this.lstActionReasons = this.lstActionReasons.filter(a => a.ReasonType == 'CLO');
                break;
            case GlitchOperationActions.CloseEdit:
                this.lstActionReasons = this.lstActionReasons.filter(a => a.ReasonType == 'CLO');
                break;
            case GlitchOperationActions.AddRecovery:
                this.lstActionReasons = this.lstActionReasons.filter(a => a.ReasonType == 'REC');
                break;
            case GlitchOperationActions.EditRecovery:
                this.lstActionReasons = this.lstActionReasons.filter(a => a.ReasonType == 'REC');
                break;
            case GlitchOperationActions.ReOpen:
                this.lstActionReasons = this.lstActionReasons.filter(a => a.ReasonType == 'REO');
                break;
            case GlitchOperationActions.ReOpenEdit:
                this.lstActionReasons = this.lstActionReasons.filter(a => a.ReasonType == 'REO');
                break;
        }
        if (this.Model.Operation == GlitchOperationActions.Delete || this.Model.Operation == GlitchOperationActions.DeleteRecovery || this.Model.Operation == GlitchOperationActions.DeleteInvestigation || this.Model.Operation == GlitchOperationActions.ReOpenDelete || this.Model.Operation == GlitchOperationActions.CloseDelete) {
            this.DeleteAction();
        }
        else{
            let ngbModalOptions: NgbModalOptions = {
                backdrop : 'static',
                size: 'lg', 
                centered: true
            };
            this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        }
    }
    DeleteAction(): void {
        let deleteText = this.translate.instant('LBL.DELETE_CONFIRM');
        let confirmDelete = confirm(deleteText + "?");
        if (!confirmDelete)
            return;
        this.SubmitStart();
        this.glitchService.Glitch_Action(this.Model).then(data => {
            this.SubmitEnd();

            if (data.HasError) {
                this.FromBaseResponse(data);
                return;
            }
            if(this.Model.Operation == GlitchOperationActions.Delete)
                this.GetMultilingualToast('TS.TS_GLITCH_DELETE_SUCCESS', 'success');
            else
                this.GetMultilingualToast('TS.TS_GLITCH_UPDATE_SUCCESS', 'success');

            this.SetModelDefaults();
            this.glitchService.TriggerRequireFullRefresh();
        });
    }
    Validate(): void {
        switch (this.Model.Operation) {
            case GlitchOperationActions.Close:
                if (this.Model.ReasonOrRecoveryId == null || this.Model.ReasonOrRecoveryId == 0) {
                    this.AddError("ERR_CLOSE_REASON_REQUIRED");
                }
                break;
            case GlitchOperationActions.AddRecovery:
            case GlitchOperationActions.EditRecovery:
                if (this.Model.ReasonOrRecoveryId == null || this.Model.ReasonOrRecoveryId == 0) {
                    this.AddError("ERR_RECOVERY_REASON_REQUIRED");
                }
                if (this.Model.RecoveryCost != null && (!/^\d+$/.test(this.Model.RecoveryCost.toString()) && !/^\d{0,}\.{1}\d{1,}$/.test(this.Model.RecoveryCost.toString()))) {
                    this.AddError("ERR_ENTER_VALID_RECOVERY_COST");
                }
                break;
            case GlitchOperationActions.AddInvestigation:
            case GlitchOperationActions.EditInvestigation:
                if (this.Model.Remarks == null || this.Model.Remarks.trim() == "") {
                    this.AddError("ERR_REMARKS_REQUIRED");
                }
                break;
        }
    }

    onSubmit(): void {
        this.ClearErrors();
        this.Validate();

        if (this.HasErrors)
            return;
        if ((this.Model.Operation == GlitchOperationActions.AddRecovery || this.Model.Operation == GlitchOperationActions.EditRecovery) && this.Model.RecoveryCost != null && this.Model.RecoveryCost > this.ApprovedMaximumCost) {
            let confirmText = this.translate.instant('LBL.RECOVERY_COST_GRREATER_THAN_MAX_COST');
            let confirmAdd = confirm(confirmText + "?");
            if (!confirmAdd)
                return;
        }
        this.SubmitStart();
        this.glitchService.Glitch_Action(this.Model).then(data => {
            this.SubmitEnd();

            if (data.HasError) {
                this.FromBaseResponse(data);
                return;
            }
            if (this.Model.Operation == GlitchOperationActions.ReOpen) {
                this.ConfirmModel = data.Result;
                let ngbModalOptions: NgbModalOptions = {
                    backdrop : 'static',
                    size: 'lg'
                };
                this.ConfirmModalRef = this.modalService.open(this.confirm, ngbModalOptions);
            }
            else 
                this.GetMultilingualToast('TS.TS_GLITCH_UPDATE_SUCCESS', 'success');
            this.SetModelDefaults();

            this.ModalRef.close();

            this.glitchService.TriggerRequireFullRefresh();
        });
    }

    setMaxDiscount(): void {
        let recoveryData = this.lstRecoveryOptions.filter(a => a.Id == this.Model.ReasonOrRecoveryId);
        this.ApprovedMaximumCost = recoveryData[0].ApprovedMaximumCost;
    }
}
